module.exports = __webpack_public_path__ + "cd455783/img/at-icon.5d6fc5d8.svg";